const userManagementPage = {
  searchUserPlaceholder: "Search for Team Member within App Directory",
  rolePlaceholder: "Select Role",
  addUserButton: "Add User",
  bulkUploadButton: "Bulk Upload",
  invite: "Invite",
  role: "Role",
  title: "User Management",
  greetings: "This page is used to manage user access to the application, as well as assigning users a high level role in the application: Basic Users cannot create new cases. Case Creators can create new cases, and assign users to that case. System Admins can create cases, assign users to any case, and modify the Users in the User List.",
  userDeleteMessage: "Do you want to remove the user: <strong>{{userName}}</strong>?",
  userInviteError: "Select a user",
  basicUser: "Basic User",
  caseCreator: "Case Creator",
  updatedRoleMessage: "User Role Updated Successfully",
  systemAdmin: "System Admin",
  userCreateMessage: "User Created Successfully",
  tableTitle: "User List",
  tableDescription: "List of all the users in the system",
  columnDetails: {
    userName: "User Name",
    addedOn: "Added On",
    applicationRole: "Application Role",
  },
};

export default userManagementPage;
